<div class="modal fade-modal" id="coverageFormModal">
  <div class="modal-dialog show2">
    <div class="modal-content">
      <div class="modal-body modal-contenido">
        <a class="back-btn title h5" (click)="openModal('#openDeliverySelector')">
          <img src="../../../assets/icons/header/arrow_left2.png" alt="icon-back" class="icon-img" />
        </a>

        <div class="col-title">
          <p class="title h3 mb-2">Indica la dirección de entrega</p>
        </div>

        <button type="button" id="closeCovarageForm" data-dismiss="modal" hidden></button>

        <a (click)="closeModal()" class="modal-close">
          <img src="../../../assets/icons/header/clear.png" alt="icon-close" class="icon-button icon-img" />
        </a>

        <!-- BUSCADOR -->
        <div class="row col-form">
          <div class="col-12">
            <label class="labels">Dirección</label>

            <input id="addressSearchInput" #searchInput type="text" class="form-control custom-opt"
              placeholder="Escribe tu dirección…" [disabled]="!apiLoaded" />

            <small *ngIf="!apiLoaded" class="text-muted">Cargando Google Maps…</small>
          </div>
        </div>

        <div class="row col-form mt-2">
          <div class="col-12">
            <label class="labels">Indicaciones</label>

            <input type="text" class="form-control custom-opt" placeholder="Ej: Apto 402, torre 3, portería..."
              [(ngModel)]="indicaciones" />
          </div>
        </div>

        <label class="label-address label-address2">
          Verifica si tu posición es correcta. Si no, arrastra el mapa para ajustar.
        </label>

        <div class="col-12 col-map">
          <ng-container *ngIf="apiLoaded; else mapLoading">
            <ng-container *ngIf="center; else mapEmpty">
              <google-map width="100%" height="300px" [center]="center" [zoom]="zoom" [options]="mapOptions">
                <map-marker [position]="center"></map-marker>
              </google-map>

              <ngx-spinner name="mapLoading" bdColor="rgba(255,255,255,0.4)" size="medium" color="#000"
                type="ball-spin-clockwise" [fullScreen]="false">
              </ngx-spinner>
            </ng-container>

            <ng-template #mapEmpty>
              <small class="text-muted">Escribe y selecciona una dirección para mostrar el mapa.</small>
            </ng-template>
          </ng-container>

          <ng-template #mapLoading>
            <small class="text-muted">Cargando mapa…</small>
          </ng-template>

        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary confirm-btn custom-btn" [disabled]="!canConfirm" (click)="confirmAddress()">
          Confirmar punto de venta
        </button>
      </div>
    </div>
  </div>
</div>
